import { useState } from "react";

import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { useConfirmDialogExit } from "hooks";
import { useSnackbar } from "providers/SnackbarProvider";
import {
  buttonAddTopic,
  formAddTopic,
  modalAddTopicSubTitle,
  modalAddTopicTitle,
  snackbarSummaryTopicAddSuccessSubTitlePart1,
  snackbarSummaryTopicAddSuccessSubTitlePart2,
  snackbarSummaryTopicAddSuccessTitle,
} from "_constants";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import { useAppDispatch } from "store/store";
import { setAddUserEmailValidation } from "store/slicer/FormAddUserValidationSlice";
import { setNameTopicValidation } from "store/slicer/FormTopicValidationSlice";
import { addNewTopic } from "services";
import { FormAddTopic } from "components/form/FormAddTopic";
import { setPageTopics } from "store/slicer/GestioneTopicsSlice";

export const ButtonAddTopic = () => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();
  const showSingleStepDialog = () => {
    dispatch(setAddUserEmailValidation(true));
    setVisible(true);
  };

  const handleAddData = () => {
    setVisible(false);
  };

  const { handleSubmit, control, trigger, getValues } = useForm({
    defaultValues: {
      id: "",
      name: "",
      description: "",
    },
    shouldFocusError: false,
    mode: "onChange",
  });
  const onSubmit = (formData: any) => {
    addNewTopic(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarSummaryTopicAddSuccessTitle,
          detail: `${snackbarSummaryTopicAddSuccessSubTitlePart1}${getValues(
            "name"
          )}${snackbarSummaryTopicAddSuccessSubTitlePart2}`,
          life: 5000,
        });
        dispatch(setPageTopics(-1));
        setTimeout(() => {
          dispatch(setPageTopics(1));
        }, 200);
        resetFormState();
      })
      .catch((error) => {
        if (error?.response?.status === 409) {
          dispatch(setNameTopicValidation(false));
        }
      });
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
  };

  return (
    <>
      <Button
        label={buttonAddTopic}
        icon={PrimeIcons.PLUS}
        onClick={showSingleStepDialog}
      />
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="369px"
        width="700px"
        header={
          <SingleStepHeaders
            title={modalAddTopicTitle}
            subtitle={modalAddTopicSubTitle}
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formAddTopic}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100 padd-top-4"
              >
                <FormAddTopic control={control} trigger={trigger} />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter
            dismiss={handleDismiss}
            form={formAddTopic}
            handleAddData={handleAddData}
          />
        }
        display={visible}
        setVisible={setVisible}
      />
    </>
  );
};
